import React from 'react';
import { Link } from 'react-router-dom';
import Mobileheader from './Mobileheader';

function Header() {
  return (
    <div>
      {/* Desktop Header */}
      <header className="homepage10-body d-none d-lg-block">
        <div id="vl-header-sticky" className="vl-header-area vl-transparent-header header-sticky">
          <div className="container">
            <div className="row align-items-center row-bg1">
              {/* Logo */}
              <div className="col-lg-2 col-md-6 col-6">
                <div className="vl-logo">
                  <Link to="/">
                    <img
                      src="/assets/img/logo/JBY-logo-83X100.png"
                      alt="JBY Logo"
                      className="site-logo"
                    />
                  </Link>
                </div>
              </div>

              {/* Main Menu */}
              <div className="col-lg-10">
                <div className="vl-main-menu text-center">
                  <nav>
                    <ul>
                      <li><Link to="/">Home</Link></li>
                      <li><Link to="/About">About Us</Link></li>
                      <li className="has-dropdown">
                        <Link to="#">Our Services</Link>
                        <ul className="sub-menu">
                          <li><Link to="/Employee_Training">Employee Training</Link></li>
                          <li><Link to="/Manpower_Sourcing">Manpower Sourcing</Link></li>
                          <li><Link to="/Corporate_Grooming_Programs">Corporate Grooming Programs</Link></li>
                          <li><Link to="/Performance_Management">Performance Management</Link></li>
                          <li><Link to="/KRAs_KPIs">KRAs & KPIs</Link></li>
                          <li><Link to="/Company_Policy_Development">Company Policy Developmnet</Link></li>
                        </ul>
                      </li>

                         <li className="has-dropdown">
                        <Link to="#">Industry Focus</Link>
                        <ul className="sub-menu">
                         <li><Link to="/Information-Technology">Information Technology</Link></li>
                          <li><Link to="/Pharmaceutical">Pharmaceutical Industry</Link></li>
                          <li><Link to="/NBFCs">Non-Banking Financial Companies (NBFCs)</Link></li>
                          <li><Link to="/DSA">Direct Selling Agents (DSA)</Link></li>
                          <li><Link to="/Real_State_Sector">Real Estate Sector</Link></li>
                           
                          
                        </ul>
                      </li>
                      <li><Link to="/Career">Careers</Link></li>
                      <li className="has-dropdown">
                        <Link to="#">Contact Us</Link>
                        <ul className="sub-menu">
                          <li><Link to="/Clients_Zone"> Client Zone</Link></li>
                          <li><Link to="/Candidate"> Candidate Zone</Link></li>
                        </ul>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>

              {/* Mobile Menu Toggle (hamburger icon) */}
              <div className="col-lg-3 d-block d-lg-none vl-header-action-item text-end">
                <button type="button" className="vl-offcanvas-toggle">
                  <i className="fa-solid fa-bars-staggered"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Header */}
      <Mobileheader />
    </div>
  );
}

export default Header;
